function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.7012 37.634L79.2673 45.2C79.3281 45.0178 79.3568 44.8264 79.3521 44.6343L79.3521 39.628C79.3506 39.0996 79.14 38.5933 78.7664 38.2197C78.3928 37.8461 77.8865 37.6355 77.3581 37.634H71.7012Z",
  fill: "#f3ad61"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.0374 37.6269L75.0389 46.6283L77.3582 46.6283C77.5128 46.6297 77.6671 46.613 77.8178 46.5788L68.8659 37.6269H66.0374Z",
  fill: "#f3ad61"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.65582 46.303L60.3383 45.6595L60.3383 49.6476C60.339 49.9118 60.4443 50.165 60.6311 50.3518C60.8179 50.5386 61.0711 50.6439 61.3353 50.6446C61.4676 50.646 61.5988 50.621 61.7214 50.5713C61.844 50.5215 61.9555 50.4479 62.0495 50.3547C62.1426 50.2608 62.2162 50.1493 62.266 50.0267C62.3157 49.9041 62.3407 49.7729 62.3394 49.6406L62.3323 46.6495L72.2318 46.6495L63.2091 37.6268L62.3535 37.6339L62.3535 34.6358C62.3544 34.3704 62.2499 34.1155 62.063 33.9272C61.876 33.7389 61.6219 33.6326 61.3565 33.6317C61.0911 33.6307 60.8363 33.7352 60.648 33.9222C60.4596 34.1092 60.3533 34.3633 60.3524 34.6287L60.3736 37.6197L2.65248 38.3056C2.3883 38.3064 2.13516 38.4117 1.94835 38.5985C1.76154 38.7853 1.65625 39.0385 1.65546 39.3027C1.65542 40.222 1.83645 41.1323 2.18824 41.9816C2.54002 42.831 3.05566 43.6027 3.70571 44.2528C4.35577 44.9028 5.1275 45.4185 5.97684 45.7702C6.82619 46.122 7.73651 46.3031 8.65582 46.303Z",
  fill: "#f3ad61"
});

var SvgNinjaSwordLeft = function SvgNinjaSwordLeft(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNinjaSwordLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ninja-sword-left.e65f0f38.svg";
export { ForwardRef as ReactComponent };